import { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@frontend/array';
import { ListOrderIdMap } from '../../types';

type UseReorderDropHandlerProps<T> = {
  list: T[];
  onChange?: (newOrderIdMap: ListOrderIdMap, newList: T[]) => void;
  listOrderIdMap: ListOrderIdMap;
};

export const useReorderDropHandler = <T extends { id: string }>({ list, onChange }: UseReorderDropHandlerProps<T>) => {
  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (over?.id && active.id !== over.id) {
      const oldIndex = list.findIndex((item) => item.id === active.id);
      const newIndex = list.findIndex((item) => item.id === over.id);

      if (onChange) {
        const { newList, newOrderIdMap } = getNewListAndOrderIdMap(list, oldIndex, newIndex);
        onChange(newOrderIdMap, newList);
      }
    }
  };

  return { onDragEnd };
};

export const getNewListAndOrderIdMap = <T extends { id: string }>(
  list: T[],
  sourceIndex: number,
  destinationIndex: number
): { newList: T[]; newOrderIdMap: ListOrderIdMap } => {
  const newList = arrayMove(list, sourceIndex, destinationIndex);
  const newOrderIdMap = getListOrderIdMap(newList);
  return { newList, newOrderIdMap };
};

export const getListOrderIdMap = <T extends { id: string }>(list: T[]) =>
  list.reduce<ListOrderIdMap>((acc, item, index) => {
    acc[item.id] = index;
    return acc;
  }, {});
